import { Slider } from '@mui/material';
import { Box } from '@mui/system';
import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';
import Info from '../../screens/Home/Info';

export default function TestHome({
  weight,
  btn,
  prefer,
  handleWeightChange,
  handleWeightClick,
  preferChoose,
  valuetext,
}) {
  const { t } = useContext(AppContext);

  return (
    <div className="home box">
      <div className="weight">
        <div className="weight-choices weight-placeholder">
          <div className="label">
            <p> {t('question')} </p>
          </div>

          <div className="weight-input weight-choose">
            <input
              type="number"
              value={weight}
              onChange={handleWeightChange}
              max={btn ? 150 : 330}
            />
            <div className="weight-btn">
              <button
                className={`btn__warning ${btn ? 'btn' : ''}`}
                disabled={btn}
                id="kg"
                onClick={handleWeightClick}
              >
                kg
              </button>
              <button
                className={`btn__warning ${!btn ? 'btn' : ''}`}
                disabled={!btn}
                id="lb"
                onClick={handleWeightClick}
              >
                lb
              </button>
            </div>
          </div>
        </div>
        <div className="weight-bar mt-4">
          <Box className="range-bar">
            <Slider
              aria-label="weight"
              getAriaValueText={valuetext}
              step={5}
              valueLabelDisplay="auto"
              sx={{ color: '#C0CDD0' }}
              onChange={handleWeightChange}
              defaultValue={0}
              max={btn ? 150 : 330}
              min={0}
              value={weight}
            />
          </Box>
        </div>
      </div>

      <div className="PreferChoices">
        <div className="label">
          <p> {t('effet_question')} </p>
        </div>
        <div className="weight-btn btn-prefer">
          {options.map((item) => {
            return (
              <OptionBtn
                key={item.id}
                option={item}
                selected={prefer}
                preferChoose={preferChoose}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

function OptionBtn({ option, selected, preferChoose }) {
  const { t } = useContext(AppContext);

  const handlePreferenceClick = () => {
    if (selected === option.name) {
      preferChoose(undefined);
    } else {
      preferChoose(option.name);
    }
  };

  return (
    <button
      className={`btn__warning Button Preference Tooltip ${
        selected === option.name ? 'btn active' : ''
      }`}
      onClick={handlePreferenceClick}
    >
      {t(translate[option.name].text)}
      <Info
        event={handlePreferenceClick}
        title={t(translate[option.name].text)}
        content={t(translate[option.name].modalContent)}
        otherContent={t(translate[option.name].otherContent)}
        parentIsActive={selected === option.name}
      />
    </button>
  );
}

const translate = {
  leger: {
    text: 'btn_leger_text',
    modalContent: 'leger_info_content',
  },
  moyen: {
    text: 'btn_moyen_text',
    modalContent: 'moyen_info_content',
  },
  intense: {
    text: 'btn_intensity_text',
    modalContent: 'intensity_info_content',
    otherContent: 'intensity_info_content_other',
  },
};
const options = [
  {
    id: 1,
    name: 'leger',
  },
  {
    id: 2,
    name: 'moyen',
  },
  {
    id: 3,
    name: 'intense',
  },
];
